import { TemperatureStatusEnum } from '../enums/temperature-status.enum';

export interface ITemperature {
    value: number;
    timeSinceLastUpdate?: number; // minutes
    lastUpdatedAt?: string; // DD/MM
    status: TemperatureStatusEnum;
}
